//import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Frame from "./Iframe";
import Spinner from "./Spinner";

class VideoGallery extends React.Component {
  state = {
    video: this.props.video,
    showModal: false,
    currentVideoId: null
  };

  componentDidMount() {
    !this.state.videoThumbs &&
      this.getThumbnail().then(data => {
        this.setState({
          videoThumbs: Object.values(data).map(ob => {
            return {
              id: ob.video_id,
              thmb: ob.thumbnail_url,
              thmb_play: ob.thumbnail_url_with_play_button
            };
          })
        });
      });
  }

  getThumbnail(videos = this.props.video) {
    let request = videos.map(id => {
      return fetch(
        `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${id}&width=640&byline=false&portrait=false&title=false&xhtml=true`
      )
        .then(data => data.json())
        .then(res => {
          return res;
        });
    });

    return Promise.all(request);
  }

  handleClick = id => {
    this.setState({
      showModal: !this.state.showModal,
      currentVideoId: id || null
    });
  };

  render() {
    // const video = this.state.video;
    // let videosArray = null;
    // video &&
    //   (videosArray = this.state.video.map(id => {
    //     return <Frame key={id} id={id} />;
    //   }));
    const title = this.props.langBase.portfolio_films_title;
    const thumbs =
      this.state.videoThumbs &&
      this.state.videoThumbs.map((ob, index) => {
        return (
          <React.Fragment>
            <div
              className="video"
              key={ob.id}
              onClick={() => {
                this.handleClick(ob.id);
              }}>
              <i
                className="playButton material-icons"
                onClick={() => {
                  this.handleClick(ob.id);
                }}>
                play_circle_outline
              </i>
              <img src={ob.thmb} alt="" />
            </div>
          </React.Fragment>
        );
      });

    return (
      <React.Fragment>
        <div className="portfolio-title">
          <span className="firstLetter">{title[0]}</span>
          <span>{title.slice(1)}</span>
        </div>
        <div className="videoGalery">
          {/* <div className="films-title">Films</div> */}
          {/* <button onClick={this.handleClick}>Show</button> */}
          {thumbs && thumbs.slice(0, 3)}
          {this.state.showModal && (
            <div
              onClick={this.handleClick}
              id="myModal"
              className="modal-custom">
              <div className="modal-content-custom">
                <Spinner />
                <button onClick={this.handleClick} className="close">
                  &times;
                </button>
                {this.state.currentVideoId && (
                  <Frame
                    key={this.state.currentVideoId}
                    id={this.state.currentVideoId}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <div className="videoGalery">
          {/* <div className="films-title">Films</div> */}
          {/* <button onClick={this.handleClick}>Show</button> */}
          {thumbs && thumbs.slice(3)}
          {this.state.showModal && (
            <div
              onClick={this.handleClick}
              id="myModal"
              className="modal-custom">
              <div className="modal-content-custom">
                <Spinner />
                <button onClick={this.handleClick} className="close">
                  &times;
                </button>
                {this.state.currentVideoId && (
                  <Frame
                    key={this.state.currentVideoId}
                    id={this.state.currentVideoId}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  langBase: state.langBase
});

export default connect(mapStateToProps)(VideoGallery);

VideoGallery.defaultProps = {
  //video: [297758118, 297748272, 299600108]
  //video: [ 260673611, 299600108, 297758118 ]
  //video: [ 357667590, 358603491, 358589548, 260673611, 297758118, 299600108]
  video: [385474388, 385472873, 357667590, 358603491, 358589548, 260673611]
};
